// extracted by mini-css-extract-plugin
module.exports = {"guide":"PaymentB_guide__2ydrF","intro":"PaymentB_intro__2rIdK","intro_1":"PaymentB_intro_1__3hT9h"};